import $ from "jquery";
export class WrappedUIElement {
    constructor(element) {
        if (typeof element === "string")
            this.element = $(element);
        else
            this.element = element;
    }
    hide() {
        this.element.addClass('hidden');
    }
    show() {
        this.element.removeClass('hidden');
    }
    on(eventName, callback) {
        this.element.on(eventName, callback);
    }
    off(eventName, callback) {
        this.element.off(eventName, callback);
    }
}
